import "./index.scss";
import PaymentMethodArrow from "assets/payment-method-arrow.png";

export const CheckoutPaymentMethod = ({
  isOpen,
  isSelector,
  isDdSelected,
  networkImg,
  last_digits,
  expiration,
  onClick
}) => (
  <button
    className={`checkout-payment-method${isSelector ? " selector" : ""}${
      isOpen ? " open" : ""
    }${isDdSelected ? " dropdown-selected" : ""}`}
    onClick={onClick}
  >
    {networkImg}
    <div className="card-info">
      <p>XXXX-XXXX-XXXX-{last_digits}</p>
      <p>Expires: {expiration}</p>
    </div>
    {isSelector && (
      <img src={PaymentMethodArrow} alt="dropdown" className="arrow" />
    )}
  </button>
);
